import React, { useState, useEffect } from "react";
import { Button, Card } from "react-bootstrap";
import Select from "react-select";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import axios from 'axios';
import { CiEdit } from "react-icons/ci";
import { FaCircleXmark } from "react-icons/fa6";
import { FiCheckCircle } from "react-icons/fi";

const ManageService = () => {
  const [showForm, setShowForm] = useState(false);
  const [getService, setGetService] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    sale_price: "",
    mrp: '',
    additional_price: '',
    category: "",
    includeDescription: '',
    excludeDescription: '',
    image: null,
    imagePreview: "",
      image2: null,
  image2Preview: "",
    min_hour: 1,
    max_hour: 1,
    is_highlight: 0,
    order_no: ''
  });
  const [categoryOptions, setCategoryOptions] = useState([{
    value: "Cleaning",
    label: "Cleaning"
  }, {
    value: "Dusting",
    label: "Dusting"
  }]);
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const [showCategoryInput, setShowCategoryInput] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [extraFields, setExtraFields] = useState([{
    heading: "",
    description: "",
    image: null
  }]);
  const handleExtraChange = (index, field, value) => {
    const updated = [...extraFields];
    updated[index][field] = value;
    setExtraFields(updated);
  };
  const handleAddRow = () => {
    if (extraFields.length >= 5) {
      showToast("Maximum 5 rows allowed!", "danger");
      return;
    }
    setExtraFields([...extraFields, {
      heading: "",
      description: "",
      image: null
    }]);
  };
  const handleRemoveRow = index => {
    const updated = extraFields.filter((_, i) => i !== index);
    setExtraFields(updated);
  };
  const inputStyle = {
    background: "var(--black)",
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.1)"
  };
  const [confirmDialog, setConfirmDialog] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null
  });
  const showConfirmDialog = ({
    title,
    message,
    onConfirm
  }) => {
    setConfirmDialog({
      show: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmDialog({
          ...confirmDialog,
          show: false
        });
      }
    });
  };
  const handleInputChange = e => {
    const {
      name,
      value,
      files
    } = e.target;
    if (name === "image") {
      setFormData({
        ...formData,
        [name]: files[0]
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  const handleCancel = () => {
    setShowForm(false);
    setIsEditMode(false);
    resetForm();
  };
  const handlePreviewImage = (url, file) => {
    if (file) {
      // preview newly selected file
      const previewUrl = URL.createObjectURL(file);
      window.open(previewUrl, "_blank");
    } else if (url) {
      // preview existing image
      window.open(url, "_blank");
    }
  };
  const handleSubmit = async e => {
    e.preventDefault();
    if (!formData.name) {
      showToast("Service name is required!", "danger");
      return;
    }
    const sendData = new FormData();

    // ✅ Basic fields
    sendData.append("name", formData.name);
    sendData.append("sale_price", formData.sale_price);
    sendData.append("mrp", formData.mrp);
    sendData.append("additional_price", formData.additional_price);
    sendData.append("category", formData.category);
    sendData.append("includeDescription", formData.includeDescription);
    sendData.append("excludeDescription", formData.excludeDescription);
    sendData.append("min_hour", formData.min_hour);
    sendData.append("max_hour", formData.max_hour);
    sendData.append("is_highlight", formData.is_highlight);
    sendData.append("order_no", formData.order_no);

    // ✅ Main image
    if (formData.image) {
      const maxSizeMB = 2;
      const fileSizeMB = formData.image.size / (1024 * 1024);
      if (fileSizeMB > maxSizeMB) {
        showToast("File size must be less than 2MB!", "danger");
        return;
      }
      sendData.append("file", formData.image);
    }

    if (formData.image2) {
  const maxSizeMB = 2;
  const fileSizeMB = formData.image2.size / (1024 * 1024);

  if (fileSizeMB > maxSizeMB) {
    showToast("Secondary image must be less than 2MB!", "danger");
    return;
  }

  sendData.append("file2", formData.image2);
}


    const filteredExtra = extraFields.filter(item => item.heading?.trim() || item.description?.trim() || item.image || item.imagePreview);
    let extraData = [];
    if (filteredExtra.length > 0) {
      extraData = filteredExtra.map(item => ({
        heading: item.heading,
        description: item.description,
        image: item.image ? item.image.name : item.imagePreview ? item.imagePreview.split("/").pop() : null,
        isNew: !!item.image
      }));
    }
    sendData.append("extra_fields", JSON.stringify(extraData));
    let isValid = true;
    filteredExtra.forEach(item => {
      if (item.image) {
        const maxSizeMB = 2;
        const fileSizeMB = item.image.size / (1024 * 1024);
        if (fileSizeMB > maxSizeMB) {
          showToast("Each execution framework image must be less than 2MB!", "danger");
          isValid = false;
        }
        sendData.append("extraImages", item.image);
      }
    });
    if (!isValid) return;
    try {
      let res;
      if (isEditMode) {
        // ✅ Handle old main image
    const oldImageFileName = formData.imagePreview
  ? formData.imagePreview.split("/").pop().split("?")[0]
  : "";

const oldImage2FileName = formData.image2Preview
  ? formData.image2Preview.split("/").pop().split("?")[0]
  : "";

sendData.append("oldImage", oldImageFileName);
sendData.append("oldImage2", oldImage2FileName);


        res = await axios.put(`https://api.sweepydo.in/update-service/${formData.id}`, sendData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        showToast("Service Updated Successfully!", "success");
      } else {
        res = await axios.post("https://api.sweepydo.in/add-service", sendData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        showToast("Service Added Successfully!", "success");
      }

      // ✅ Reset
      setShowForm(false);
      setIsEditMode(false);
      resetForm();
      fetchService();
    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);
      // showToast("Failed to save service!", "danger");
      showToast(err.response?.data?.message || "Failed to save service!", "danger");
    }
  };

const handleEdit = (form) => {
  setIsEditMode(true);

  let parsedExtra = [];

  try {
    parsedExtra = form.extra_fields
      ? JSON.parse(form.extra_fields)
      : [];
  } catch (err) {
    console.log("Invalid JSON:", err);
  }

  const formattedExtra = parsedExtra.map((item) => ({
    heading: item.heading || "",
    description: item.description || "",
    image: null,
    imagePreview: item.image
      ? `https://api.sweepydo.in/uploads/${item.image}`
      : null,
  }));

  setFormData({
    id: form.id,
    name: form.name || "",
    sale_price: form.sale_price || "",
    mrp: form.mrp || "",
    additional_price: form.additional_price || "",
    category: form.category || "",
    includeDescription: form.includeDescription || "",
    excludeDescription: form.excludeDescription || "",
    min_hour: form.min_limit || 1,
    max_hour: form.max_limit || 1,
    order_no: form.order_no || "",
    image: null,
    imagePreview: form.image
      ? `https://api.sweepydo.in/uploads/${form.image}`
      : "",
    image2: null,
    image2Preview: form.front_img
      ? `https://api.sweepydo.in/uploads/${form.front_img}`
      : "",
    is_highlight: Number(form.is_highlight ?? 0),
  });

  setExtraFields(
    formattedExtra.length > 0
      ? formattedExtra
      : [{ heading: "", description: "", image: null }]
  );

  setShowForm(true);
};

//   const handleEdit = async form => {
//     setIsEditMode(true);
//     let parsedExtra = [];
//     try {
//       parsedExtra = form.extra_fields ? JSON.parse(form.extra_fields) : [];
//     } catch (err) {
//       console.log("Invalid JSON:", err);
//     }
//     const formattedExtra = parsedExtra.map(item => ({
//       heading: item.heading || "",
//       description: item.description || "",
//       image: null,
//       imagePreview: item.image ? `https://api.sweepydo.in/uploads/${item.image}` : null,
//       image2: null,
// image2Preview: form.image2 ? `https://api.sweepydo.in/uploads/${form.image2}` : null,
//     }));

//     // ✅ set main form data
//     setFormData({
//       id: form.id,
//       name: form.name || "",
//       sale_price: form.sale_price || "",
//       mrp: form.mrp || "",
//       additional_price: form.additional_price || "",
//       category: form.category || "",
//       includeDescription: form.includeDescription || "",
//       excludeDescription: form.excludeDescription || "",
//       min_hour: form.min_limit || "",
//       max_hour: form.max_limit || "",
//       order_no: form.order_no || "",
//       imagePreview: form.image ? `https://api.sweepydo.in/uploads/${form.image}` : null,
//       is_highlight: form.is_highlight ?? 0
//     });
//     setExtraFields(formattedExtra.length > 0 ? formattedExtra : [{
//       heading: "",
//       description: "",
//       image: null
//     }]);
//     // setEditingCompanyId(form.id);
//     setShowForm(true);
//   };
  const handleStatus = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === "Active" ? "Inactive" : "Active";
      await axios.put(`https://api.sweepydo.in/update-service-status/${id}`, {
        status: newStatus
      });
      showToast(`Service ${newStatus} successfully`, 'success');
      fetchService();
    } catch (err) {
      console.error("Error updating status:", err);
      showToast("Failed to update service status", 'danger');
    }
  };
  const fetchService = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-all-service");
      const result = res.data;
      setGetService(result);
      const categoriesFromServices = [...new Set(result.map(s => s.category))];
      const backendCategoryOptions = categoriesFromServices.map(cat => ({
        value: cat,
        label: cat
      }));
      setCategoryOptions(prevOptions => {
        const allOptions = [...prevOptions, ...backendCategoryOptions];
        const uniqueOptions = Array.from(new Map(allOptions.map(opt => [opt.value, opt])).values());
        return uniqueOptions;
      });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchService();
  }, []);
  const resetForm = () => {
    setFormData({
      name: "",
      sale_price: "",
      mrp: '',
      additional_price: '',
      category: "",
      includeDescription: '',
      excludeDescription: '',
      image: null,
      imagePreview: "",
    image2: null,
    image2Preview: "",
      min_hour: 1,
      max_hour: 1,
      is_highlight: 0,
      order_no: ''
    });
    setExtraFields([{
      heading: "",
      description: "",
      image: null
    }]);
  };
  const filteredData = Array.isArray(getService) ? getService.filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  return <div className="main-page">

      <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />
      <p className="main-page-heading">Manage Services</p>

  
    

      {showForm && <div className="main-page-area mb-3">
          <form onSubmit={handleSubmit}>

            <div className="row mb-3">
              
              <div className="col-lg-4 col-md-6 col-12">
                <label className="form-label">Service Name</label><br />
                <input type="text" name="name" value={formData.name} onChange={handleInputChange} className="main-input-control2" required />
              </div>

              <div className="col-lg-4 col-md-6 col-12">
                <label className="form-label">Market Price</label><br />
                <input type="number" name="mrp" value={formData.mrp} onChange={handleInputChange} className="main-input-control2" required />
              </div>

              <div className="col-lg-4 col-md-6 col-12">
                <label className="form-label">Sale Price</label><br />
                <input type="number" name="sale_price" value={formData.sale_price} onChange={handleInputChange} className="main-input-control2" />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-lg-4 col-md-6 col-12">
                <label className="form-label">Add on Cost (every +30 mins)</label><br />
                <input type="number" name="additional_price" value={formData.additional_price} onChange={handleInputChange} className="main-input-control2" />
              </div>





              <div className="col-md-4">
                <label className="form-label">Category</label><br />

                <div className="d-flex gap-2">
                  {/* React Select */}
                  <Select options={categoryOptions} value={categoryOptions.find(opt => opt.value === formData.category)} onChange={selected => setFormData({
                ...formData,
                category: selected.value
              })} className="w-100" placeholder="Select category" required />

                  
                  <button className="btn main-btn2" onClick={() => setShowCategoryInput(true)}>
                    +
                  </button>
                </div>


                {showCategoryInput && <div className="mt-2 d-flex gap-2">
                    <input type="text" className="main-input-control2" placeholder="New category" value={newCategory} onChange={e => setNewCategory(e.target.value)} />
                    <button type="button" className="btn main-btn1" onClick={() => {
                if (!newCategory.trim()) return;

                // Create a new option
                const newOption = {
                  value: newCategory.trim(),
                  label: newCategory.trim()
                };
                setCategoryOptions([...categoryOptions, newOption]);
                setFormData({
                  ...formData,
                  category: newCategory.trim()
                });

                // Reset input
                setNewCategory("");
                setShowCategoryInput(false);
              }}>
                      Save
                    </button>
                  </div>}
              </div>

              <div className="col-lg-4 col-md-6 col-12">
                <label className="form-label">Upload Image</label><br />
               

            <div className="d-flex">
                <input type="file" name="image" className="main-input-control2" onChange={e => setFormData({
                ...formData,
                image: e.target.files[0]
              })} required={!isEditMode} />
                                 {isEditMode && formData.imagePreview && <div className="ms-2 align-content-center">
      <button type="button" className="btn main-btn2" onClick={() => handlePreviewImage(formData.imagePreview, formData.image)}>
        Preview
      </button>
    </div>}</div>
              </div>


<div className="col-lg-4 col-md-6 col-12 mt-2">
  <label className="form-label">Front Image</label>
  <div className="d-flex">
    <input
      type="file"
      name="image2"
      accept="image/*"
      className="main-input-control2"
      onChange={e =>
        setFormData({
          ...formData,
          image2: e.target.files[0]
        })
      }
    />

    {isEditMode && formData.image2Preview && (
      <button
        type="button"
        className="btn main-btn2 ms-2"
        onClick={() =>
          handlePreviewImage(formData.image2Preview, formData.image2)
        }
      >
        Preview
      </button>
    )}
  </div>
</div>


            </div>

          

            <div className="row mb-3">
              <div className="col-lg-4 col-md-6 col-12">
                <label className="form-label">Service includes (use | to display in next line)</label><br />
                <textarea name="includeDescription" value={formData.includeDescription} onChange={handleInputChange} className="main-input-control2" rows="4" placeholder="Enter include description...(For new line seperate by | here) " />
              </div>

              <div className="col-lg-4 col-md-6 col-12">
                <label className="form-label">Does not include (use | to display in next line)</label><br />
                <textarea name="excludeDescription" value={formData.excludeDescription} onChange={handleInputChange} className="main-input-control2" rows="4" placeholder="Enter exclude description... (For new line seperate by | here)" />
              </div>

                <div className="col-lg-4 col-md-6 col-12">
                <label className="form-label">Order Number</label><br />
                <input type="number" name="order_no" value={formData.order_no} onChange={handleInputChange} className="main-input-control2" required />
              </div>
            </div>

            <div className="row mb-3">


      <div className="col-lg-4 col-md-6 col-12 mb-3">
                  <label className="form-label">Min Service Duration/ Limit</label><br />

<div className="d-flex">
<div>                <input type="number" name="min_hour" value={formData.min_hour} onChange={handleInputChange} className="main-input-control2" />
              </div>
<div className="align-content-center ms-2 border rounded-2 px-3 ">{formData.min_hour * 30} Mins</div>
</div>
</div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                  <label className="form-label">Max Service Duration/ Limit</label><br />

<div className="d-flex">
<div>                <input type="number" name="max_hour" value={formData.max_hour} onChange={handleInputChange} className="main-input-control2" />
              </div>
<div className="align-content-center ms-2 border rounded-2 px-3 ">{formData.max_hour * 30} Mins</div>
</div>
</div>
            

              <div className="col-lg-4 col-md-6 col-12 mb-3">
      <input className="form-check-input" type="checkbox" id="is_highlight" checked={formData.is_highlight === 1} onChange={e => setFormData({
              ...formData,
              is_highlight: e.target.checked ? 1 : 0
            })} />
   <label className="form-label ms-2">Add to Highlights</label><br />
    </div>

 

</div>
            

 <div className="row mb-3">


  <div className="d-flex justify-content-between">

                    <label className="form-label fw-semibold">Execution Framework</label>
    <button type="button" className="btn main-btn2" onClick={handleAddRow}>
      + Add More
    </button>
  </div>




    <div className="table-responsive my-2">
      <table className="table table-bordered text-white align-middle">

        <thead>
          <tr>
            <th style={{
                    backgroundColor: "var(--black2)",
                    color: "#fff"
                  }}>Heading</th>
            <th style={{
                    backgroundColor: "var(--black2)",
                    color: "#fff"
                  }}>Description</th>
            <th style={{
                    backgroundColor: "var(--black2)",
                    color: "#fff"
                  }}>Upload Image</th>
            <th style={{
                    backgroundColor: "var(--black2)",
                    color: "#fff"
                  }}>Action</th>
          </tr>
        </thead>

        <tbody>
          {extraFields.map((row, index) => <tr key={index}>

              {/* Heading */}
              <td style={{
                    backgroundColor: "var(--black)",
                    color: "#fff"
                  }}>
                <input type="text" className="main-input-control2" value={row.heading} onChange={e => handleExtraChange(index, "heading", e.target.value)} />
              </td>

              {/* Description */}
              <td style={{
                    backgroundColor: "var(--black)",
                    color: "#fff"
                  }}>
                <input type="text" className="main-input-control2" value={row.description} onChange={e => handleExtraChange(index, "description", e.target.value)} />
              </td>

              <td className="d-flex" style={{
                    backgroundColor: "var(--black)",
                    color: "#fff"
                  }}>

                  {/* {row.imagePreview && (
                   <img
                   src={row.imagePreview}
                   alt="preview"
                   style={{ width: "50px", height: "50px", objectFit: "cover" }}
                   />
                   )} */}

  
                <input type="file" className="main-input-control2" onChange={e => handleExtraChange(index, "image", e.target.files[0])} />
                  {(row.imagePreview || row.image) && <button type="button" className="btn btn-sm btn-info ms-2" onClick={() => handlePreviewImage(row.imagePreview, row.image)}>
      Preview
    </button>}
              </td>

              <td style={{
                    backgroundColor: "var(--black)",
                    color: "#fff"
                  }}>
                <button className="btn main-btn2" onClick={() => handleRemoveRow(index)}>
                  Remove
                </button>
              </td>

            </tr>)}
        </tbody>

      </table>
    </div>

 </div>


            <div className="d-flex justify-content-end mb-2">
              
              <button type="submit" className="btn main-btn1 me-2">
                {isEditMode ? "Update" : "Save"}
              </button>

              <button className="btn main-btn2" onClick={handleCancel}>
                Cancel
              </button>
            </div>
          </form>

        </div>}


     
      
  <div className="main-page-area">

  
    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">

      <input type="text" className="main-input-control col-lg-3 col-md-5 col-12" placeholder="Search services by name , category..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />

      <button onClick={() => setShowForm(true)} className="btn main-btn1">
        Add Service
      </button>

    </div>


    <div className="table-responsive main-page-table">
      <table className="w-100 table text-center">
        <thead>
          <tr>
       
                 <th>Order No</th>
            <th>Service</th>
            <th>MRP</th>
            <th>Sale Price</th>
            <th>Category</th>
            <th>Action</th>
</tr>        </thead>

        <tbody>
          {filteredData.map((s, i) => <tr key={s.id}>
             
               <td>
                {s.order_no || "-"}
              </td>

              <td>
                {s.name}
              </td>

              <td>{s.mrp}</td>

              <td>
                {s.sale_price}
              </td>

              <td>
                {s.category}
              </td>

              <td>
  <div style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px"
                }}>
  
    <div onClick={() => handleEdit(s)} title="Edit">
      <CiEdit size={20} color="#0d6efd" />
    </div>


<div title={s.status === "Active" ? "Deactivate" : "Activate"} onClick={() => {
                    setSelectedService(s);
                    setShowStatusModal(true);
                  }}>

                    {s.status == 'Active' ? <FaCircleXmark size={20} className="cursor-pointer text-danger"  />
                    : <FiCheckCircle size={20} className="cursor-pointer text-success"  />}
  
</div>
            </div>
          </td>
        </tr>)}
    </tbody>
  </table>
</div>

</div>
  


      {showStatusModal && selectedService && <div className="modal fade show d-block" tabIndex="-1">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content" style={{
          backgroundColor: "var(--black2)",
          color: "#fff"
        }}>
        <div className="modal-header">
          <h5 className="modal-title">
            {selectedService.status === "Active" ? "Deactivate Service" : "Activate Service"}
          </h5>

        </div>

        <div className="modal-body">
          <p>
            Are you sure you want to{" "}
            <strong>
              {selectedService.status === "Active" ? "deactivate" : "activate"}
            </strong>{" "}
            this service?
          </p>
        </div>

        <div className="modal-footer">
          <button className="btn main-btn2" onClick={() => setShowStatusModal(false)}>
            Cancel
          </button>

          <button className={selectedService.status === "Active" ? "btn btn-danger" : "btn btn-success"} onClick={() => {
              handleStatus(selectedService.id, selectedService.status);
              setShowStatusModal(false);
            }}>
            {selectedService.status === "Active" ? "Deactivate" : "Activate"}
          </button>
        </div>
      </div>
    </div>
  </div>}

    </div>;
};
export default ManageService;
